import { ROUTE } from "../../routes";
import { generateUniqueId } from "../../configs/utils";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { StoreKey } from "../../configs/api";
import { AppLink } from "../../configs/constants";
export const onTrackPendingCustomerJourney = async (action, _datastore, standardUtilities) => {
    const customerType = action?.payload?.customerType;
    if (customerType === 'PENDING_REGISTRATION') {
        standardUtilities.instrumentTrack("ASSISTED_JOURNEY_BUTTON_CLICKED", {
            "page": "leads"
        });
        const pan = action?.payload?.pan;
        const phoneNumber = action?.payload?.phoneNumber;
        const preFill = action?.payload?.preFill;
        if (preFill) {
            await standardUtilities.navigate(ROUTE.REGISTER_LEADS, { isPrevRouteLeads: true, pan, phoneNumber, preFill });
        }
        else {
            await standardUtilities.navigate(ROUTE.REGISTER_LEADS, { isPrevRouteLeads: true });
        }
    }
    else {
        const trackingId = await generateUniqueId();
        await AsyncStorage.setItem('trackingId', trackingId);
        standardUtilities.instrumentTrack('PLJ_LOAD_INITIATED', { trackingId: trackingId });
        const user = action.payload.value;
        const borrowerAccountId = user?.accountId;
        const userName = user.fullName;
        const applicationId = user?.applicationId;
        const phoneNumber = user?.phoneNumber;
        await AsyncStorage.setItem("pljName", userName);
        await standardUtilities.asyncStorage.set(StoreKey.PLJ_borrowerAccountId, borrowerAccountId);
        await standardUtilities.navigate(ROUTE.VOLT_APP, { borrowerAccountId: borrowerAccountId, name: userName, applicationId: applicationId, phoneNumber: phoneNumber });
    }
};
export const onShareLink = async (action, _datastore, standardUtilities) => {
    console.warn('**** onShareLink Action Triggered ****', action);
    const user = action?.payload.user;
    console.log("User 123: ", user);
    const phoneNumber = user.borrowerAccountProfile.phoneNumber ? user.borrowerAccountProfile.phoneNumber : '';
    const link = `${AppLink}?user=${phoneNumber.slice(3)}&sts=1`;
    if (user) {
        standardUtilities.navigate(ROUTE.INVITE_CLIENT, {
            _link: link,
            _title: 'Directly share the Volt Money app link with your customers.',
            _headerTitle: 'Share link with customer',
            _removeBanner: true
        });
    }
};
export const navigateToLeadScreen = async (action, _datastore, { navigate }) => {
    const currentPage = action?.payload?.currentPage;
    const currentPendingCustomerActiveTabIndex = action?.payload?.currentActiveTabIndex;
    const searchContext = action?.payload?.searchContext;
    await navigate(ROUTE.PARTNER_LEAD, { currentPage, currentPendingCustomerActiveTabIndex, searchContext });
};
